const selectColorApp: {
  color: string;
}[] = [
  {
    color: "#A33685",
  },
  {
    color: "#52459E",
  },
  {
    color: "#0A8A8D",
  },
  {
    color: "#379734",
  },
  {
    color: "#135A8D",
  },
  {
    color: "#B82020",
  },
];

export default selectColorApp;
